var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"root",staticClass:"dh-psy-carousel",attrs:{"slot":"item"},slot:"item"},_vm._l((_vm.imageSrc),function(image,idx){return _c('div',{key:image + idx,class:{
      'carousel-cell': true,
      'nrk-sr': !_vm.ready && idx > 0,
      'carousel-cell--43': image.aspect === '4:3',
      'carousel-cell--34': image.aspect === '3:4',
      'carousel-cell--163': image.aspect === '16:3',
      'carousel-cell--11': image.aspect === '1:1',
      'carousel-cell--169': !image.aspect || image.aspect === '16:9',
    }},[_c('Esi',{attrs:{"src":((image.src) + "&size=10" + (image.caption ? ("&caption=" + (image.caption)) : ''))}})],1)}))}
var staticRenderFns = []

export { render, staticRenderFns }